export const Male = {
    name: 'Male',
    value: 'MALE',
};
export const Female = {
    name: 'Female',
    value: 'FEMALE',
};
export const Unknown = {
    name: 'Unknown',
    value: 'UNKNOWN',
};
const Basic = [Male, Female, Unknown];
const BasicByValue = Basic.reduce((hash, gender) => {
    hash[gender.value] = gender;
    return hash;
}, {});
export default { Basic, BasicByValue, Male, Female, Unknown };
